export function dateSetter(fromDateSetter, toDateSetter, date) {
  fromDateSetter(() => {
    let d = new Date();
    d.setDate(d.getDate() - date);
    return d;
  });

  toDateSetter(() => {
    let d = new Date();
    d.setDate(d.getDate() + 2);
    return d;
  });
}
